<div id="beforeYouBegin">
  <!--
    if client has any unsupported features, go to coming_soon,
    else before_you_begin
  -->
  <ng-container *ngIf="unsupported.length; then coming_soon; else before_you_begin"> </ng-container>

  <ng-template #coming_soon>
    <label><strong>Coming Soon</strong></label>
    <div>
      We are not quite ready for payrolls with {{ unsupported[0] }}. We will let you know when new
      functionality is available. For now, please enter this client's payroll in the APS system.
    </div>
  </ng-template>
  <ng-template #before_you_begin>
    <div *ngIf="errors.length || warnings.length">
      <label><strong>Before you Begin</strong></label>
      <div class="py-2 px-2 card card--light card--short">
        <ul *ngIf="errors.length" class="m-0">
          <li *ngFor="let error of errors" class="d-flex align-items-center my-2">
            <div class="relay-icon relay-icon--error mx-2"></div>
            <span>{{ error }}</span>
          </li>
        </ul>
        <ul *ngIf="warnings.length" class="m-0">
          <li *ngFor="let warning of warnings" class="d-flex align-items-center my-2">
            <div class="relay-icon relay-icon--warning mx-2"></div>
            <span
              >{{ warning }}
              <a
                [routerLink]="baseUrl + '/' + (clientCode | async) + '/approvals'"
                *ngIf="warning.includes('employee change request') && canAccessChangeRequests"
                >View Requests</a
              ></span
            >
          </li>
        </ul>
      </div>
    </div>
  </ng-template>
</div>
